import { NgModule } from '@angular/core';
import { MysupportEvaluationComponent } from './mysupport-evaluation.component';

@NgModule({
	declarations: [],
	imports: [MysupportEvaluationComponent],
	exports: [MysupportEvaluationComponent],
})
export class MysupportEvaluationModule {}
